export default __webpack_public_path__ + "static/b-corp-logo-ed644f4e4ac90d000fd8c455099773f7.svg";